// 事件名称枚举
export const DocEvent = {
  STEP_CHANGE: 'onStepChange',
  PAGE_CHANGE: 'onSlideChange',
  READY: 'ready',
  /** 全局播放完毕事件 */
  PLAYBACKCOMPLETE: 'playbackComplete',
  /** 页码、步数、每步时间 */
  ANIMATIONINFO: 'animationInfo'
};

// 画笔事件枚举
export const DoodleEvent = {
  ADD: '*add',
  MODIFY: '*modify',
  REMOVE: '*remove',
  REMOVE_ALL: '*remove_all',
  SELECTED: '*selected',
  DESELECTED: '*deselected',
  SELECT_CHANGED: '*selectchanged',
  UNDO: '*undo',
  REDO: '*redo'
};
